<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class>
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item label="姓名" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input placeholder="请输入真实姓名" v-decorator="[
              'fullName',
              { rules: [{ required: true, message: '请输入真实姓名!' }], initialValue: info.fullName }
            ]"></a-input>
          </a-form-item>
          <a-form-item label="联系方式" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input placeholder="请输入手机号码" v-decorator="[
              'telephone',
              { rules: [{ required: false, message: '请输入手机号码!' }], initialValue: info.telephone }
            ]"></a-input>
          </a-form-item>
          <a-form-item label="用户名" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input placeholder="请输入用户名" v-decorator="[
              'userName',
              { rules: [{ required: true, message: '请输入用户名!' }], initialValue: info.userName }
            ]"></a-input>
          </a-form-item>
          <a-form-item label="排序号" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input placeholder="请输入排序号" v-decorator="[
              'orderNo',
              { rules: [{ required: false, message: '请输入排序号!' }], initialValue: info.orderNo }
            ]"></a-input>
          </a-form-item>
          <a-form-item label="身份证号" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input placeholder="请输入身份证号" v-decorator="[
              'idCard',
              { rules: [{ required: false, message: '请输入身份证号!' }], initialValue: info.idCard }
            ]"></a-input>
          </a-form-item>
          <a-form-item label="性别" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-radio-group @change="onChange" v-decorator="[
              'sex',
              { rules: [{ required: true, message: '请选择性别!' }], initialValue: info.sex }
            ]">
              <a-radio :value="1">男</a-radio>
              <a-radio :value="2">女</a-radio>
            </a-radio-group>
          </a-form-item>

          <a-form-item label="简介" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <!-- <a-textarea
              placeholder="请输入简介"
              v-decorator="[
                'introduction',
                {rules: [{ required: false, message: '请输入简介!' }],initialValue:info.introduction}
              ]"
              :rows="4"
            /> -->
            <vue-ueditor-wrap v-model="info.introduction" :config="myConfig"></vue-ueditor-wrap>
          </a-form-item>
          <a-form-item label="所属单位" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input placeholder="请输入所属单位" v-decorator="[
              'company',
              { rules: [{ required: false, message: '请输入所属单位!' }], initialValue: info.company }
            ]"></a-input>
          </a-form-item>
          <a-form-item label="职称" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input placeholder="请输入职称" v-decorator="[
              'title',
              { rules: [{ required: false, message: '请输入职称!' }], initialValue: info.title }
            ]"></a-input>
          </a-form-item>
          <a-form-item label="上传照片" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-upload :action="$api.file.uploadFile" listType="picture-card" :fileList="fileList" @preview="handlePreview"
              @change="handleChange">
              <div v-if="fileList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </a-form-item>
          <a-form-item label="是否推荐" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-switch v-model="info.recommend" v-decorator="[
              'recommend',
              { rules: [] }
            ]" />
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
            <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
          </a-form-item>
        </a-form>
      </div>
    </div>
  </a-spin>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
var that;
export default {
  props: {
    infos: {
      type: Object,
      default: () => { }
    },
    id: 0
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {
        number: "",
        startTime: "",
        endTime: ""
      },
      recommend: 0,
      isloading: false,
      loadingTip: "加载中...",
      fileList: [],
      previewVisible: false,
      previewImage: "",
      uploadImg: [],
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: this.$api.file.uploadUpFile,
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: "/UEditor/"
      },
    };
  },
  components: {
    VueUeditorWrap
  },
  mounted() {
    this.$nextTick(function () {
      that = this;
      if (this.id) {
        //编辑
        this.getInfo();
      }
      if (!this.type) {
        this.dis = true;
      }
    });
  },
  methods: {
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    /**数据回显 */
    getInfo() {
      this.isloading = true;
      this.$api.teacher
        .getById(this.id)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info = res.data;
            this.info.recommend = this.$commen.changeIntBoolean(
              res.data.recommend
            );
            res.data.recommend = this.$commen.changeIntBoolean(
              res.data.recommend
            );
            if (res.data.sex) {
              this.info.sex = res.data.sex == "男" ? 1 : 2;
            } else {
              this.info.sex = "";
            }
            if (res.data.company) {
              this.info.company = res.data.company;
            } else {
              this.info.company = "";
            }
            if (res.data.title) {
              this.info.title = res.data.title;
            } else {
              this.info.title = "";
            }
            if (res.data.photoUrl.length > 0) {
              var pics = res.data.photoUrl.split(",");
              for (var i = 0; i < pics.length; i++) {
                this.fileList.push({
                  uid: i,
                  name: "头像" + (i + 1) + ".png",
                  status: "done",
                  url: pics[i]
                });
              }
            }
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    //性别选择
    onChange(e) {
      this.info.sex = e.target.value;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.uploadImg = [];
          this.fileList.forEach(function (item, index) {
            if (item.url) {
              that.uploadImg.push(item.url);
            } else {
              that.uploadImg.push(item.response.data.path);
            }
          });
          //修改
          this.isloading = true;
          this.loadingTip = "保存中...";
          var paramData = {
            fullName: values.fullName,
            sex: this.info.sex == 1 ? "男" : "女",
            orderNo: values.orderNo ? values.orderNo : "",
            userName: values.userName,
            idCard: values.idCard ? values.idCard : "",
            telephone: values.telephone ? values.telephone : "",
            introduction: this.info.introduction ? this.info.introduction : "",
            company: values.company ? values.company : "",
            title: values.title ? values.title : "",
            photoUrl: that.uploadImg.join(","),
            recommend: values.recommend
              ? this.$commen.changeBooleanInt(values.recommend)
              : this.$commen.changeBooleanInt(this.info.recommend)
          };
          if (this.id) {
            paramData.id = this.id;
          }
          this.$api.teacher
            .saveOrUpdate(paramData)
            .then(res => {
              this.isloading = false;
              if (res.errorCode == this.$msg.responseCode.success) {
                this.$message.success(res.errorMsg);
                this.$emit("callbackMethod");
              } else {
                this.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              this.isloading = false;
            });
        }
      });
    },
    handleCancel() {
      this.previewVisible = false;
    },
    beforeUpload(file, fileList) {
      var isJPGPNG = false;
      if (file.type === "image/jpeg" || file.type === "image/png") {
        isJPGPNG = true;
      } else {
        isJPGPNG = false;
        this.$message.error("只能上传jpg/png格式的文件!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("文件不能超过2MB!");
      }
      return isJPGPNG && isLt2M;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange(info) {
      if (info.file.status) {
        this.fileList = info.fileList;
      }
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
.scheduleBtn {
  color: #1890ff;
  cursor: pointer;
}
</style>